import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkText, UitkHeading } from "uitk-react-text";

import SavingBadge from "../shared/SavingBadge";
import { getFormattedHotelDates } from "components/flexComponents/Packages/utils/PackageDates";

import { PricesAndDateProps } from "components/flexComponents/Packages/typings";

const PricesAndDate: React.FC<PricesAndDateProps> = ({
  packageItem,
  renderSavingBadge,
  renderDates,
  renderSpace,
  overImage,
}) => {
  const { formatText } = useLocalization();

  return (
    <UitkLayoutFlex direction="column" alignItems="end">
      {renderSavingBadge && (
        <SavingBadge markers={packageItem.markers} renderSpace={renderSpace} overImage={overImage} />
      )}
      <del className="uitk-type-300 all-l-padding-half">{packageItem.packagePriceNoSavings}</del>
      <UitkHeading size={600} level={4}>
        {packageItem.formattedPrice}
      </UitkHeading>
      <UitkLayoutFlex direction="column" alignItems="end">
        <UitkText size={100}>{formatText("recentSearches.perPerson")}</UitkText>
        {renderDates && (
          <UitkText size={100}>
            {getFormattedHotelDates({
              checkInDate: packageItem.isoCheckInDate,
              checkOutDate: packageItem.isoCheckOutDate,
            })}
          </UitkText>
        )}
      </UitkLayoutFlex>
    </UitkLayoutFlex>
  );
};

export default PricesAndDate;
